import ExpandMoreIcon from "@mui/icons-material/ExpandMore"
import {Button, Menu, MenuItem, Typography} from "@mui/material"
import React, {useContext, useRef, useState} from "react"
import {ActionContext} from "../../../../context/ActionContextProvider"

const RisikoortItem = ({risikoort, deleteDisabled}) => {
    const {triggerAction} = useContext(ActionContext)
    const [anchorEl, setAnchorEl] = useState(null)
    const containerRef = useRef(null)
    const open = Boolean(anchorEl)

    const onHover = event => {
        setAnchorEl(event.currentTarget)
    }

    const closeMenu = () => {
        setAnchorEl(null)
    }

    const handleEdit = () => {
        closeMenu()
        triggerAction("SELECT_RISIKOORT", risikoort)
    }

    const handleDelete = () => {
        closeMenu()
        triggerAction("DELETE_RISIKOORT", risikoort)

    }

    return (
        <>
            <Button
                ref={containerRef}
                onMouseEnter={onHover}
                variant="contained"
                endIcon={<ExpandMoreIcon />}
            >
                <Typography>{risikoort.bezeichnung}</Typography>
            </Button>
            <Menu
                id={`name-actions-menu`}
                anchorEl={anchorEl}
                open={open}
                onClose={closeMenu}
                slotProps={{
                    paper: {onMouseLeave: closeMenu},
                }}
                anchorOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
                transformOrigin={{
                    vertical: "top",
                    horizontal: "right",
                }}
            >
                <MenuItem onClick={handleEdit}>Bearbeiten</MenuItem>
                <MenuItem onClick={handleDelete} disabled={deleteDisabled}>Löschen</MenuItem>
            </Menu>
        </>
    )
}

export default RisikoortItem
